import { serializable, alias, primitive } from 'serializr';
export class Metrics {
    @serializable(alias('time', primitive()))
    time?: string;
  
    @serializable(alias('completeness', primitive()))
    completeness?: string;
  
    @serializable(alias('reliability', primitive()))
    reliability?: string;
  
    @serializable(alias('geography', primitive()))
    geography?: string;
  
    @serializable(alias('technology', primitive()))
    technology?: string;
  }